import { TransformedFiles } from "@core/models/designTool";

export function getFileName(file): string {
    // get the filename from the file path without the file extension
    const filename = file.id.split('/').pop().split('.')[0];
    return filename;
}


export function analyzeImage(file: TransformedFiles): TransformedFiles {
    const img = new Image()
    img.crossOrigin = "Anonymous";
    img.onload = () => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      if (!ctx) {
        console.error('Canvas 2D not supported by the browser');
        return;
      }
      canvas.width = img.width;
      canvas.height = img.height;
      ctx.drawImage(img, 0, 0, img.width, img.height);

      // get pixels data
      const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
      const data = imageData.data;
      // Check the dominant color
      let transparentCount = 0
      for (let i = 0; i < data.length; i += 4) {
        const a = data[i + 3];
        if (a != 255) {
          transparentCount++;
        }
      }
      file.hasTransparentBackground = transparentCount > 0
    };
    img.src = file.imageUrl
    return file
  }